module.exports = __webpack_public_path__ + "static/media/r8.9ae42375.jpg";